// products modules
import axios from 'axios';
import { PRODUCT_GREAT_DEALS_URL, MOBILE_URL, SEARCH_PRODUCT_URL } from '../../api/url.js';

// initial state
const state = {
}

// actions
const actions = {
  fetchProducts: (context, data) => {
    let b2b = context.rootState.auth.userDetails.IsBusiness;
    let config = {}
    if (b2b) {
       config = {
        url: `${SEARCH_PRODUCT_URL}${data}`,
        method: 'GET',
        params: {
          isB2B: b2b,
        }
      }
    } else if (!b2b) {
      config = {
        url: `${SEARCH_PRODUCT_URL}${data}`,
        method: 'GET',
      }
    }
   return axios(config)
  }
};

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js